import _ from 'lodash'

// initial state
const state = {
	navigator: {
		screen: 'sp',
		userAgent: 'Unknown',
		version: '',
		mobile: '',
		online: navigator.onLine,
		standalone: true,
		isAvailable: true
	}
}

// getters
const getters = {
	getNavigator: state => state.navigator
}

// actions
const actions = {
	/**
	 * 端末情報を保持する
	 * @param  {ActionContext} commit vuexのaction指定
	 * @param  {Object} values Navigatorオブジェクト
	 */
	setNavigator ({ commit }, values) {
		commit('SET_NAVIGATOR', values)
	}
}

// mutations
const mutations = {
	/**
	 * 端末情報を保持する
	 * @param  {Object} state このモジュールのstate
	 * @param  {Object} values Navigatorオブジェクト
	 */
	'SET_NAVIGATOR' (state, values) {
		_.forEach(values, (_value, _key) => {
			state.navigator[_key] = values[_key]
		})
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
